import {
  isQarGroupKey,
  isQarKey,
  isQarQuestionKey,
  QarGroupKey,
  qarGroups,
  QarKey,
  QarQuestionKey,
} from './qarForm.config'
import {
  isQasGroupKey,
  isQasKey,
  isQasQuestionKey,
  QasGroupKey,
  qasGroups,
  QasKey,
  QasQuestionKey,
} from './qasForm.config'
import {
  isQsaGroupKey,
  isQsaKey,
  isQsaQuestionKey,
  QsaGroupKey,
  qsaGroups,
  QsaKey,
  QsaQuestionKey,
} from './qsaForm.config'
import {
  isQBSGroupKey,
  isQBSKey,
  isQBSQuestionKey,
  QBSGroupKey,
  qbsGroups,
  QBSKey,
  QBSQuestionKey
} from './qbsForm.config'
import {
  isQFSGroupKey,
  isQFSKey,
  isQFSQuestionKey,
  QFSGroupKey,
  qfsGroups,
  QFSKey,
  QFSQuestionKey
} from './qfsForm.config'

export const allGroups = {
  ...qarGroups,
  ...qasGroups,
  ...qsaGroups,
  ...qbsGroups,
  ...qfsGroups,
}

export type QaGroupKey = QarGroupKey | QasGroupKey | QsaGroupKey | QBSGroupKey | QFSGroupKey
export type QaQuestionKey = QarQuestionKey | QasQuestionKey | QsaQuestionKey | QBSQuestionKey | QFSQuestionKey
export type QaMetricId = QarKey | QasKey | QsaKey | QBSKey | QFSKey

export const isQaGroupKey = (id: string): id is QaGroupKey =>
  isQarGroupKey(id) || isQasGroupKey(id) || isQsaGroupKey(id) || isQBSGroupKey(id) || isQFSGroupKey(id)
export const isQaQuestionKey = (id: string): id is QaQuestionKey =>
  isQarQuestionKey(id) || isQasQuestionKey(id) || isQsaQuestionKey(id) || isQBSQuestionKey(id) || isQFSQuestionKey(id)
export const isQaMetricId = (id: string): id is QaMetricId =>
  isQarKey(id) || isQasKey(id) || isQsaKey(id) || isQBSKey(id) || isQFSKey(id)